import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslations } from "@jti/ui";
export const MonthlyPurchaseButtonContent = () => {
    const { __ } = useTranslations();
    return (_jsxs("ol", { children: [_jsx("li", { children: __("sticksForm.purchase_options.subscription.monthly.bullet.1") }), _jsx("li", { children: __("sticksForm.purchase_options.subscription.monthly.bullet.2") }), _jsx("li", { children: __("sticksForm.purchase_options.subscription.monthly.bullet.3") })] }));
};
//# sourceMappingURL=MonthlyPurchaseButtonContent.js.map